import { CognitoUser } from "@aws-amplify/auth";

// https://vuex.vuejs.org/en/state.html

export default {
  userInfo : CognitoUser,
  licenseData : null,
  showSnack : false,
  snackColor : "",
  snackText: "",
  isCurrentUserPowerUser : false,
  adminUsersList : [],
  availableLidars : {},
  allowFeaturesList : []
}
